import React from 'react'
import HTMLReactParser from 'html-react-parser'
import domToReact from 'html-react-parser/lib/dom-to-react'
import {
  UnHighlightMark,
  ParagraphLeftBlock,
  ParagraphCenterBlock,
  ParagraphRightBlock,
  ParagraphBlock,
  BulletedListBlock,
  NumberedListBlock,
  ListItemBlock,
  LinkMark,
  LinkTextMark,
  RichTextContainer
} from './Elements'
import * as C from './constants'

const componentBlockWrapper = (options, children) => (Component, props = {}) => {
  return (
    <Component {...options} {...props}>
      {domToReact(children, createParserOptions(options))}
    </Component>
  )
}

// responsible for what are shown in 'Image With Text' section
const createParserOptions = (options) => {
  return {
    replace: ({ attribs, children, name }) => {
      const withWrapper = componentBlockWrapper(options, children)

      switch (name) {
        case 'p': {
          if (options.normalised) {
            return withWrapper(ParagraphBlock, { normalised: true })
          }

          if (!attribs.style) {
            return
          }

          if (attribs.style.includes(C.LEFT)) {
            return withWrapper(ParagraphLeftBlock)
          }

          if (attribs.style.includes(C.RIGHT)) {
            return withWrapper(ParagraphRightBlock)
          }

          return withWrapper(ParagraphCenterBlock)
        }

        case 'ul':
          return withWrapper(BulletedListBlock)

        case 'ol':
          return withWrapper(NumberedListBlock)

        case 'li':
          return withWrapper(ListItemBlock)

        case 'a':
          return withWrapper(LinkMark, { href: attribs.href })

        case 'span': {
          if (attribs.style && attribs.style.includes(C.HIGHLIGHT_COLOR)) {
            return withWrapper(UnHighlightMark)
          }
          return withWrapper(LinkTextMark)
        }

        default:
          return null
      }
    }
  }
}

const parser = (htmlText, options = {}) => {
  return (
    <RichTextContainer color={options.color}>
      {HTMLReactParser(htmlText, createParserOptions(options))}
    </RichTextContainer>
  )
}

export default parser
